import React, { Component } from 'react';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import ConstCommon from '../../common/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import {
  getCodeFromQuery,
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from '../../helpers/Common';
import {
  changeCurrentSearch,
  fetchDataSnapshotSearch,
  REDUCER_NAME,
  subscribeRealtimePrice,
} from './reducer';
import { connect } from 'react-redux';
import './FASnapshot.scss';
import PreRender from './../../common/PreRender';
import TemplatePDF from './common/TemplatePDF';
import ScrollComponent from '../../common/ScrollComponent';
import { Provider } from './../../common/ComponentIdContext';
import Info from './Info';
import Chart from './Chart';
import { compose } from 'redux';
import { withComponentId } from './../../common/ComponentIdContext';
import { ComponentNameProvider } from './../../common/ComponentNameContext';
import FAHead from './FAHead';
import withRealtime from './../../common/withRealtime';
import SmallFAHead from './SmallFAHead';

const SMALL_WIDTH = 700;

class FASnapshot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
    const { changeCurrentSearch, id, fetchDataSnapshotSearch } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      changeCurrentSearch(codeFromQuery, id);
      fetchDataSnapshotSearch(codeFromQuery, id);
    }
  }

  componentDidMount() {
    const {
      glContainer,
      fetchDataSnapshotSearch,
      currentSearch,
      id,
    } = this.props;
    removeDragCode(glContainer);
    if (!getQueryParams('code')) {
      fetchDataSnapshotSearch(currentSearch, id);
    }
  }

  onSizeInfo = size => {
    if (size.width) {
      this.setState({ width: size.width });
    }
  };

  isSmall = () => {
    const { width } = this.state;

    return width < SMALL_WIDTH;
  };

  render() {
    const { id, dragCode } = this.props;
    const { width } = this.state;
    const idFormExport = 'fa-snapshot-export' + id;

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.FASnapshot}>
            <div className="top-nav snapshot-wrapper h-100">
              <ScrollComponent>
                <div className="pr-20 pl-20 pt-8 pb-10 w-100" id={idFormExport}>
                  {this.isSmall() ? (
                    <SmallFAHead id={id} dragCode={dragCode} />
                  ) : (
                    <FAHead id={id} dragCode={dragCode} />
                  )}
                  <div className="fa-body-content">
                    <Info onSize={this.onSizeInfo} />
                    <Chart key={width} width={width} />
                  </div>
                </div>
              </ScrollComponent>
              <TemplatePDF />
            </div>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id }) => ({
  currentSearch: state[REDUCER_NAME].listMultiComponent[id].currentSearch,
  syncType: syncComponentSelector(
    state,
    ConstCommon.listComponent.FASnapshot,
    id,
  ),
});

const mapDispatchToProps = {
  subscribeRealtimePrice,
  fetchDataSnapshotSearch,
  changeCurrentSearch,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRealtime(ChanelConfig.TickChanel, 'subscribeRealtimePrice'),
  withSyncDragCode,
)(FASnapshot);
